/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import React from 'react';
import Feeds from './feeds.jsx';
import Tabs from './tabs/tabs.jsx';
import {fetchFeed, get, search} from '../apiFunctions';
import {settingsToParams} from '../util';
// import {fetchLocationData, fallbackGeoFromLang} from '../geolocation';
// import bla from '../geolocation';
import { connect } from 'react-redux';
import store from '../store';

import T from 'i18n-react';
import { gotoView } from '../actions/view';
import { updateMenu } from '../actions/feed';
import { setFocusedPuff } from '../actions/puff';
import { browserHistory } from 'react-router';

// import {setGeoLocation} from '../actions/app';
// import TimeAgo from 'react-timeago'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

import Modal from './modal/modal.jsx';
import Checkout from './modal/checkout.jsx';
// import Terminal from './modal/terminal.jsx';
import Login from './page/login.jsx';
import MessageBox from './modal/messagebox.jsx';
import BigPuff from './puff/bigpuff.jsx';
import MobileArticle from './puff/mobileArticle.jsx';
import Onboarding from "./modal/onboarding.jsx";

var VfImage = require('./media/vfImage.jsx')
var MonokVideo = require('./media/monokVideo.jsx')

var ReactGA = require('react-ga')
var config = require('../../settings/config.json');
var langNames = require('../../locale/lang.json');

let Scroll = require('react-scroll');
let scroll = Scroll.animateScroll;

var lFormatter = null

class PapayaApp extends React.Component {

  constructor(props){
    //IE FIX
    

    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    }

    console.log("MONOK 2025 - Hello Developer, You're awesome and we love you!")
    super(props);
    this.onResize = this.onResize.bind(this);
    this.setTop = this.setTop.bind(this);

    let brand = props.location.query && props.location.query.embed ? {
      logo: props.location.query.logo,
      color: '#'+props.location.query.color
    } : null

    if(props.location.pathname === '/login'){
      brand = true;
    }

    this.state = {mobile:this.isMobile(),
                  smallWidth:this.isSmallWidth(), 
                  top:true, 
                  embed:brand,
                  citeNotice:props.location.query && props.location.query.citeNotice,
                  vf:props.location.query && props.location.query.vf,
                  onboard:props.location.pathname === '/onboard',
                  vid:props.location.query && props.location.query.vid,
                  slid:props.location.query && props.location.query.slid
                }
  }

  componentDidUpdate(prevProps, prevState){
    //When adding/removing a feed manually OR when you're logging out and the selectedView beomes -1 for some reason
    if((prevProps.feeds.length !== this.props.feeds.length) || (this.props.selectedView===-1 && prevProps!==-1)){
      //Remove from the new feed all the feeds that lack the focus attribute

      //Check if new feed added
      let candidate = this.props.feeds.find(f=>!prevProps.feeds.find(of=>f.id===of.id))
   
      
      if(!candidate){
        let candidates = this.props.feeds.filter(feed=>feed.focus)
        candidate = candidates[0]
   
      }

      if(candidate && this.feedPath(candidate) === prevProps.location.pathname){
        store.dispatch(gotoView(candidate));
      }else if(candidate){
        browserHistory.push({pathname: this.feedPath(candidate)})   
      }
      
    }

    let paths = this.props.location.pathname.split('/')
    let feedName = paths[1]
    if(feedName ==='puff'){
      document.title=(this.props.selectedPuff && this.props.selectedPuff.puff ? this.props.selectedPuff.puff.title+' - ' : '')+config.app.title
    }
  }

  componentWillReceiveProps(nextProps){
      if(this.props.location.pathname !== nextProps.location.pathname || this.props.location.query !== nextProps.location.query){
      // if(this.props.location.pathname !== nextProps.location.pathname || this.props.location.query.q !== nextProps.location.query.q){
        // console.log("CHANGED!!!!!!!!!!!!!!!!!!!!!!!!!!")
        window.status=null
        this.pageChange(nextProps.location)
      }
  
  }

  pageChange(location){

  

      let query = location.query
      // console.log("CHAAANGGEEEED")
        // console.log(location)
        //TODO: check initialization before running GA funcs
      if(process.env.NODE_ENV==='production'){
        ReactGA.pageview(location.pathname);
      }

      let paths = location.pathname.split('/')
      let feedName = paths[1]
      // query.category = query.category ? query.category : paths[2]

      let currentTab = this.props.feeds[this.props.selectedView]

      //Alias
      if(feedName==='puff'){
        var id = paths[2]
        // console.log(id)
        // console.log(this.props.feeds)
        // console.log(this.props.selectedPuff)
        if(!(this.props.selectedPuff && this.props.selectedPuff.puff)){
          if(location.action === 'POP'){
            // console.log("FETCHING PUFF ##########################################")
            get('puff/'+id,(err, res)=>{
              if(res.body){
                // console.log(this.props.location.query)
                let loggedIn = this.props.user && this.props.user.email
                if(loggedIn && res.body && res.body.length>0){
                  res.body.tabId = currentTab.id
                  document.title = res.body.title + " - " + config.app.title
                  store.dispatch(setFocusedPuff(id, res.body));
                }else{
                  // console.log(this.props.location.query)
                  // console.log(location.query)
                  // }else if(this.props.location.query && !this.props.location.query.signin){
                  // browserHistory.push({pathname: location.pathname, query:{signin:true}})
                }
              }
            })
          }
          // console.log('PUFF!! '+id)

        }
        // if(query.feed){
        //   feedName = query.feed
        // }else{
          return
        // }

      }else{
        //Deselect all puffs
        store.dispatch(setFocusedPuff(0));
      }

      let feedIndex = -1
      if(!['404','410'].includes(window.status)){
        if(feedName === 'feed'){
          feedIndex = this.props.feeds.findIndex((feed)=>{return feed.id === decodeURI(paths[2]) && feed.prefix && feed.prefix==='feed'})
        }else{
          feedIndex = this.props.feeds.findIndex((feed)=>{return feed.id === feedName})
        }  
      }

      let feedNotFound = false
      //Feed not found or none was given (base url) go to last tab (Landing page), else go to selectedView
      if(feedIndex === -1){
        feedIndex = feedName === '' ? this.props.feeds.length-1 : this.props.selectedView
        feedNotFound = true
      }

      let f = this.props.feeds[feedIndex]
     
      //######### Set Menu (this is done in backend too) #########
      let menuChanged = false
      let previousParams = settingsToParams(f)
      let params = {}
      if(f && f.menu){
        let sub = feedName==='feed' ? (paths[3] ? paths[3] : '') : (paths[2] ? paths[2] : '');
        
        if(f.id==='profile'){
          query.page = sub
        }else{
          query.category = sub
        }
        // console.log(query)
        // console.log(f)
        // f.id ==='profile' ? query.page = sub : query.category=sub;

        // f.id === 'profile' ? query.page = sub : query.category = sub

        f.menu.forEach(m=>{
          if(query[m.type] || query[m.type]===''){
            let newValue = m.value.toLowerCase() === query[m.type].toLowerCase()    
            menuChanged = !menuChanged && m.selected!==newValue ? true : menuChanged
            m.selected = newValue
          }
        })
        //The new params
        params = settingsToParams(f)
      }
      //##########################################################



      if(this.props.selectedView !== feedIndex){
        store.dispatch(gotoView(f));
        this.setTop(true)
      }else{
        // console.log("clicked on same page")
      }

      let statusTitles = {
        '404':'Page Not Found',
        '410':'Page has beed removed'
      }

      if(!feedNotFound){
        document.title =  (statusTitles[window.status] ? statusTitles[window.status] : T.translate(f.title) + (query.category ? ' ' + query.category : '')) + " - " + config.app.title;
      }
      //If there's a search query, make a search
      // console.log('THING HAPPENED')
      // console.log(f.lastRequest)
      // console.log(query.q)
      // console.log(params)
      // console.log(query)

      let changed = f && f.puffs && (f.puffs.length<1 || query.refresh || menuChanged)
      let queryChanged = (f && f.lastRequest && f.lastRequest.query ? f.lastRequest.query : '') !== (query.q ? query.q : ((params && params.q) ? params.q : ''))
      let loggedIn = this.props.user && this.props.user.email

      if(menuChanged){
        this.props.updateMenu(f)
      }
     
      // console.log(queryChanged)
      if(changed && f.id !== 'search'  && !f.private && (f.id !== 'profile' || (f.id === 'profile' && !params.page))){ //&& f.id !== 'profile'
        // console.log('fetching feed')
        fetchFeed(f);
      }else if(!['404','410'].includes(window.status) && (changed || queryChanged) && f.id === 'search' && (['free'].includes(params.feed) || (['store','orders'].includes(params.feed) && loggedIn))){
        
        // console.log(query)
        // console.log(previousParams)
        // console.log(params)
        // console.log(changed)
        // console.log(queryChanged)

        if(!queryChanged && previousParams && params && previousParams.feed!== params.feed && loggedIn){
          query.q=''
        }
        document.title = (query.q ? query.q +' - ' : '') + T.translate(f.title) + (query.category ? ' ' + query.category : '') + ' - ' + config.app.title;
        f.product = query.q ? null : 'landingpage'
        search(query.q, 0, f)
      }
   
      //view changed
      // console.log(previousParams)
      // console.log(params)


      if(previousParams && params && (previousParams.view !== params.view || previousParams.page !== params.page)){
        this.setTop(true)
      }

      if(changed || queryChanged || this.props.selectedView !== feedIndex){
        // console.log('AHA')
        f && f.id ? this.gotoTop(f.id) : null
      }

  }

  gotoTop(index){
    // console.log('SCROLL TO TOP '+index+(true ? "-scroll" : "-pagescroll"))
    scroll.scrollToTop({
        duration: 500,
        delay: 100,
        smooth: true,
        containerId: index+"-scroll"
    })
  }

  getLocale(){
    //Browser language
    var hl = this.props.location.query.hl ? this.props.location.query.hl : 'en'
    //Set the browser language as the locale of the user
    var locale = hl

    if(hl && hl.indexOf('-') > -1){
      locale = hl.split('-')[0]
    }
    return locale
  }

  setHomeAsLocalLanguage(){
    let acceptedLocale = config.locale.accepted
    // let mapping = {se:'sv'} //temporary
    let locale = this.getLocale()

    // console.log(locale)
    let timeagoLang = null
    let timeagoLangShort = null
    // if(locale==='sv'){
    //   T.setTexts(require('../../locale/sv.json'));
    //   timeagoLang = require('../../locale/timeago/sv');
    // }else if(locale==='de'){
    //   T.setTexts(require('../../locale/de.json'));
    //   timeagoLang = require('react-timeago/lib/language-strings/de');
    // }else if(locale==='es'){
    //   T.setTexts(require('../../locale/es.json'));
    //   timeagoLang = require('react-timeago/lib/language-strings/es');
    // }else if(locale==='ja'){
    //   T.setTexts(require('../../locale/ja.json'));
    //   timeagoLang = require('react-timeago/lib/language-strings/ja');
    // }else if(locale==='ar'){
    //   T.setTexts(require('../../locale/ar.json'));
    //   timeagoLang = require('react-timeago/lib/language-strings/ar');
    // }else{
      T.setTexts(require('../../locale/en.json'));
      timeagoLang = require('../../locale/timeago/en');
    // }

    timeagoLangShort = require('react-timeago/lib/language-strings/en-short');
    timeagoLangShort = timeagoLangShort ? timeagoLangShort : timeagoLang

    window.timeagoFormatter = buildFormatter(timeagoLang.default)
    window.timeagoFormatterShort = buildFormatter(timeagoLangShort.default)

    // Set map location to nearby
    // fetchLocationData(locale, (res)=> {});

  }

  isMobile(){
     return window.innerWidth<800
  }

  isSmallWidth(){
     return window.innerWidth<1500
  }

  feedPath(feed){
    return '/' + (feed.prefix ? feed.prefix + '/' : '') + feed.id
  }

  componentWillMount(){
    this.setHomeAsLocalLanguage()
  }

  componentDidMount() {
    // const selectedView = this.props.selectedView
    // console.log(this.props.feeds)
    // console.log(this.props.user)

    if( typeof window !== 'undefined' ){
      window.addEventListener('resize', this.onResize, false)
    }

    if(this.props.location.query.q && typeof this.props.location.query.q!==undefined){
      document.title = this.props.location.query.q+" "+T.translate(this.props.feeds[this.props.selectedView].title)+' - '+config.app.title;
      // search(location.query.q)
    }else{
      this.pageChange(this.props.location)
    }
  }

  deselectPuffs(){
      let selectedFeed = this.props.feeds[this.props.selectedView]
      if(this.props.selectedPuff.puff){
        if(this.props.selectedPuff.options && this.props.selectedPuff.options.parent){
          this.props.setFocusedPuff(0);
        }else if(selectedFeed.id==='search'){
          browserHistory.push({pathname: this.feedPath(selectedFeed)}) //
        }else{
          browserHistory.goBack()
        }
      }
  }

  componentWillUnmount () {
    if( typeof window !== 'undefined' )
      window.removeEventListener('resize', this.onResize)
  }

  onResize(){
    let change = {}
    if(this.isMobile() && !this.state.mobile){
      change.mobile = true
    }else if(!this.isMobile() && this.state.mobile){
      change.mobile = false
    }
    if(this.isSmallWidth() && !this.state.smallWidth){
      change.smallWidth = true
    }else if(!this.isSmallWidth() && this.state.smallWidth){
      change.smallWidth = false
    }

    if(change.smallWidth !== undefined || change.mobile !== undefined  ){
      this.setState(change)
    }
  }

  setTop(is){
    this.setState({top:is})
  }


  render() {

    let selectedPuff = this.props.selectedPuff
    let selectedFeed = this.props.feeds[this.props.selectedView]
    let puffFeed = selectedPuff && selectedPuff.puff ? this.props.feeds.find(feed=>feed.id===selectedPuff.puff.feed) : null
 
    let {embed, vf, vid, slid, citeNotice, mobile} = this.state

    let puff = selectedPuff && selectedPuff.puff ? selectedPuff.puff : null

    let checkout = puff ? (puff.cluster && puff.sources.length>0 && !(selectedPuff.options && selectedPuff.options.parent)) : ((selectedPuff.options && selectedPuff.options.checkout) ? true : false)
  
    let signin = this.props.location.query && this.props.location.query.signin
    let newArticle = this.props.location.query && this.props.location.query.new && this.props.location.query.new==='draft'
    let redirect = this.props.location.query && this.props.location.query.redirect ? this.props.location.query.redirect : window.location.pathname

    // let targetFeed = this.props.location.feed ? this.props.location.feed : null
    let options = this.props.location.query ? Object.keys(this.props.location.query).reduce((a,key)=>({...a, [key]: this.props.location.query[key].toLowerCase()==='false' ? false :  this.props.location.query[key]}),{}) : {}

    if((vf || vid || slid) && puff){
      return <div>
          { vid || slid ? <MonokVideo record={options.record} 
                              feed={puffFeed} 
                              slides={slid}
                              logo={options.logo}
                              format={options.format}
                              article={puff} 
                              options={options}
                              controls={!slid && !options.embed}/> :
            <VfImage 
                    id={'visualFocusContainer'}
                    article={puff}
                    bigPuff={true} 
                    onReady={()=>{
                      // this.setState({vfReady:true})
                    }}
                    feed={puffFeed}
                    citeNotice={citeNotice}
                    forScreenshot={true}
                    vf={puff.visualFocus}/>
            }
        </div>
    }else if(this.state.onboard){
      return <Onboarding theme="dark"  mobile={mobile} newFeed={true} user={{name:"", email:"", agree:true}}></Onboarding>
    }else if(signin || selectedFeed.id === 'login' || (!this.props.user || !this.props.user.email)){
      return <Login redirect={redirect}/>
    }

    if(newArticle){
      checkout = true
      puff = {title:"New Article", type:'new', sources:[], id:'new', sources:[]}
    }


    return <div style={style.container}> 
              {mobile ? 
                (puff && mobile ? 
                  ((checkout ? <Checkout availableFeeds={this.props.feeds} targetFeed={selectedFeed.id === 'search' ? null : selectedFeed.id} isMobile={true} article={puff} /> : 
                      <MobileArticle content={selectedPuff} key={"mainPuff"} id={"mainPuff-"+puff.id}  single={true} isLinear={true}  article={puff} ></MobileArticle>)) : null)
                : 
              <Modal content={selectedPuff} user={this.props.user}>
                {(puff) ? 
                  ((checkout ? <Checkout availableFeeds={this.props.feeds} targetFeed={selectedFeed.id === 'search' ? null : selectedFeed.id} article={puff} /> : 
                      <BigPuff mobile={mobile} puffFeed={puffFeed} selectedFeed={selectedFeed} smallWidth={this.state.smallWidth} writeAccess={selectedPuff.options ? selectedPuff.options.writeAccess : false} key={"landingpage-"+selectedPuff.id} id={"landingpage-"+puff.id}  single={true} isLinear={true}  article={puff} style={{maxWidth:800, marginLeft:'auto',marginRight:'auto', marginBottom:200}}/>)
                    ) : null}
              </Modal>}
              <Tabs {...this.props} mobile={mobile} top={this.state.top}/>
              <MessageBox style={style.row}/>
              <Feeds  {...this.props} redirect={redirect} onTop={this.state.top} setTop={this.setTop} mobile={mobile}/>
            </div>
  }
}
                 
const style={
    row:{textAlign:'center', display: 'flex', flexDirection: 'column'},
    container:{
      height: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow:'hidden'
    }
}

const mapStateToProps = function(store) {
  return {
    feeds: store.feeds,
    user:store.auth.user,
    // feeds: store.profile.feeds,
    selectedView: store.feeds.findIndex(f=>f.id === store.view.selectedView),
    // geoLocation: store.app.geoLocation,
    selectedPuff: store.puff.selectedPuff
  };
};

function mapDispatchToProps(dispatch) {
  return {
    updateMenu: (feed, menu) => dispatch(updateMenu(feed, menu)), 
    setFocusedPuff: (id)=>dispatch(setFocusedPuff(id))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(PapayaApp);